/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import Form from "../../../../components/Form";
import Modal, { ModalHeader } from "../../../../components/Modal";
import useForm from "../../../../hooks/useForm";
import {
  createSalariesItems,
  modifySalariesItems,
} from "../../../../apis/salary/salary-items";
import { viewLoading } from "../../../../utils/loading";
import { findModeLabel } from "../../../../utils/mode";
import systemAlert from "../../../../utils/systemAlert";

const Payment = ({ list, mode, open, setOpen, submit }) => {
  const [formFields] = useState([
    [{ title: "항목명", key: "name", type: "input", required: true }],
    [{ title: "항목코드", key: "code", type: "input", required: true, validators: ['number'] }],
    [
      {
        title: "사용여부",
        key: "isActive",
        type: "radio",
        options: {
          list: [
            { label: "사용", value: "1" },
            { label: "미사용", value: "0" },
          ],
        },
        required: true,
      },
    ],
  ]);

  useEffect(() => {
    setValidateFields(formFields)
    if (mode === "create") {
      setValues({
        name: "",
        code: "",
        isActive: "1",
      });
    } else {
      const formData = {
        name: list.name,
        code: list.code,
        isActive: list.isActive ? "1" : "0",
      };
      setValues(formData);
    }
  }, [mode, list, formFields]);

  const _submit = (form) => {
    const data = {
      ...form,
      type: "allowance",
      isActive: Boolean(Number(form.isActive)),
    };

    if (mode === "create") {
      systemAlert('지급항목을 추가하시겠습니까?', {
        buttons: [
          {
            color: 'text',
            label: '취소'
          },
          {
            label: '승인',
            onClick: () => {
              viewLoading(true)
              createSalariesItems(data)
                .then(() => {
                  submit();
                  reset();
                  setOpen(false);
                })
                .catch((err) => {
                  console.error(err.response);
                })
                .finally(() => {
                  viewLoading(false);
                });
            }
          }
        ]
      })
    } else {
      systemAlert('지급항목을 수정하시겠습니까?', {
        buttons: [
          {
            color: 'text',
            label: '취소'
          },
          {
            label: '승인',
            onClick: () => {
              viewLoading(true)
              modifySalariesItems(list.idx, data)
                .then(() => {
                  submit();
                  setOpen(false);
                })
                .catch((err) => {
                  console.error(err.response);
                })
                .finally(() => {
                  viewLoading(false);
                });
            }
          }
        ]
      })
    }
  };

  const {
    form,
    setValues,
    errors,
    handleOnChange,
    handleSubmit,
    reset,
    setValidateFields
  } = useForm(
    {
      name: "",
      code: "",
      isActive: "1",
    },
    _submit,
  );

  const cancel = (e) => {
    e.preventDefault();
    setOpen(false);
    if (mode === "create") reset();
  };

  return (
    <Modal isOpen={open} close={cancel}>
      <div className="payment-write">
        <ModalHeader>
          지급 항목 {findModeLabel(mode)}
        </ModalHeader>
        <Form
          mode={mode}
          fields={formFields}
          form={form}
          onChange={handleOnChange}
          submit={handleSubmit}
          cancel={cancel}
          errors={errors}
        />
      </div>
    </Modal>
  );
};

export default Payment;
